'use strict';

/**
 * Component for the object status
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../../templates/components/detail/field-status.hbs');

var StatusComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'actionLayerStatus': '.action-layer-status',
        'showStatus': '[data-action="show-status"]',

        // 'statusSelect': 'input[name="status"]',
        // 'relationInput': 'input[name="relation"]',
    },

    events: {
        // 'change @ui.statusSelect': 'onChangeStatusSelect',
        'click @ui.showStatus': 'showStatus',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        // relationField: function() {
        //     return this.relationField;
        // },

        hasStatusLayer: function() {
            if (App.isShare()) {
                return false;
            }

            // Check license
            if (!App.user.get('licenseStorages') && this.model.get('objectStatus') === 'in-collection') {
                return false;
            }

            var status = this.model.get('objectStatus');
            var statusRelation = this.model.get('objectStatusRelation') || '';
            var storageId = this.model.get('storageId');

            return (status === 'in-collection' && storageId)
                || ((status === 'lent' || status === 'deaccessioned') && statusRelation.length > 0);
        },

        properStatus: function() {
            var field = this.getOption('field');

            var status = this.model.get('objectStatus') || '';

            if (App.CollectionModule) {
                var statusModel = App.CollectionModule.statusCollection.get(status);
                if (statusModel) {
                    status = statusModel.get('name');
                }
            } else if (status.length > 0) {
                status = App.t('collection::object:details:object-status:' + status + ' :label')
            }

            return status;
        },

    },

    initialize: function() {
        // var field = this.getOption('field');
        // var sourceFields = field.sourceFields;
        // var catalog = this.model.collection.catalog;

        // this.relationField = catalog.getFieldDefinition(sourceFields.relation);
    },

    /**
     * Is triggered, when the status is clicked
     * We will open the actions overlay
     * @param {object} event The click event
     */
    showStatus: function(event) {
        var $curTarget = $(event.currentTarget);
        var pos = $curTarget.offset();
        var extraPos = $('#extra-content').offset();

        this.ui.actionLayerStatus.css({
            top: pos.top - extraPos.top - this.getPxSize(2) + 'px',
            left: pos.left - extraPos.left - this.getPxSize(1) + 'px',
        }).addClass('is-visible');

        // Close actions overlay on next click
        event.stopPropagation();
        $('body').one('click', function() {
            this.hideStatus();
        }.bind(this));
    },

    hideStatus: function() {
        this.ui.actionLayerStatus.removeClass('is-visible');
    },

    onResize: function() {
        this.hideStatus();
    },

    hasValue: function() {
        return true;
    },
});

module.exports = StatusComponent;